export const getQueryKeys = {
  tasks: ({ fromDate, toDate, workerId }) => [
    'tasks',
    fromDate,
    toDate,
    workerId,
  ],
  request: (requestId) => ['request', requestId],
};
